var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"candle-app-icon",attrs:{"href":_vm.href,"target":"_blank"}},[_c('span',{staticClass:"candle-app-icon-wrap"},[_c('font-awesome-icon',{attrs:{"icon":[_vm.type, _vm.icon]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }